import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ICustomerReportHistoryResponse } from "../../typings/interfaces/responses";
import { GET_CUSTOMER_REPORT_HISTORY } from "../../configs/apiConfig";

export const getCustomerReportHistoryAction = createAsyncThunk(
  "customer/reportHistory",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<{ body: ICustomerReportHistoryResponse[] }>(
        GET_CUSTOMER_REPORT_HISTORY(customerId)
      );
      return response.data.body;
    } catch (err: any) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);
